const optionsCategoriesTwoMobile = 
    {
        margin: 20,
        responsiveClass: true,
        dots: true,
        smartSpeed: 1000,
        autoplay:false,
        autoplayTimeout:3000,
        autoplayHoverPause:false,
        nav: false,
        navText: ["<div class='nav-button owl-prev'>‹</div>", "<div class='nav-button owl-next'>›</div>"],
        responsive: {
            0: {
                items: 1,
            },
            400: {
                items: 1,
            },
            600: {
                items: 2,
            },
            735: {
                items: 3,
            },
            1000: {
                items: 3,

            },
            1600: {
                items: 3,

            }
        },
    }

export default optionsCategoriesTwoMobile;